const webStorage = {
  async getItem(key) {
    try {
      const storage =
        typeof window !== 'undefined' ? window.localStorage : null;
      if (!storage) {
        return null;
      }
      const value = storage.getItem(key);
      return value == null ? null : value;
    } catch (_e) {
      return null;
    }
  },

  async setItem(key, value) {
    try {
      const storage =
        typeof window !== 'undefined' ? window.localStorage : null;
      if (!storage) {
        return;
      }
      storage.setItem(key, String(value));
    } catch (_e) {}
  },

  async removeItem(key) {
    try {
      const storage =
        typeof window !== 'undefined' ? window.localStorage : null;
      if (!storage) {
        return;
      }
      storage.removeItem(key);
    } catch (_e) {}
  },

  async multiGet(keys) {
    const rows = await Promise.all(
      keys.map(async key => [key, await webStorage.getItem(key)]),
    );
    return rows;
  },
};

export const migrateLegacyStorageKeys = async _staticKeys => {
  return {migratedCount: 0, migratedKeys: []};
};

export default webStorage;
